import BaseStore from 'stores/BaseStore';

class MetaFieldStore extends BaseStore {
  constructor() {
    super('meta-fields', 'meta_field', { site_model: true })
  }
}

export default new MetaFieldStore()
